module.exports = __webpack_public_path__ + "static/media/shopHeroImage.8ef8fd5e.png";